<template>
    <v-dialog v-model="show" persistent width="300">
        <v-card color="lime" dark>
            <v-card-text>
                {{ text }}
                <v-progress-linear indeterminate color="white" class="mb-0"></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
  export default {
    name: 'LoaderModalDialog',
    props: {
      text: String,
      show: Boolean
    },
    data: () => ({

    }),
  }
</script>

<style scoped>

</style>